<template>
    <v-layout>
        <workflow-tree-item 
            @itemSelected="itemSelected" 
            @branchOpened="branchOpened"          
            @branchClosed="branchClosed"                
            :item="tree"             
            :currentSelectedItem="currentSelectedItem">
        </workflow-tree-item>
    </v-layout>
</template>
<script>
    import Vue from 'vue'
    import { mapGetters } from 'vuex'
    import * as types from '../../store/types'
    import workflowTreeItem from './workflowTreeItem.vue'
    export default {
        data() {
            return { 
                
            }
        },
        props: ['items','currentSelectedItem'],
        computed: {
            tree(){
                if(!this.items || !this.items.length){
                    return {name:"leeg"}
                }                
                return this.items[0]
            }
        },        
        methods:{ 
            branchOpened(e){
                this.$emit('branchOpened', e)
            },
            branchClosed(e){
                this.$emit('branchClosed', e)
            },
            itemSelected(e){                
                this.$emit('itemSelected', e)
            }            
        },
        mounted(){

        },
        components:{
            workflowTreeItem
        }
    }
</script>

<style scoped>

</style>